// @flow
import axios from "axios";
import TVGConf from "@tvg/conf";
import { tvgHeaders } from "./utils";
import type { Address, User } from "../Types.js.flow";

export type ProfileResponse = {
  error: ?{
    status: string,
    message: string
  },
  success: ?{
    status: string,
    data: {
      user: User
    }
  }
};

type ResponseUser = {
  data: {
    accountNumber: string,
    firstName: string,
    lastName: string,
    primaryPhone: string,
    wagerStatus: number,
    emailAddress: string,
    homeAddress: Address,
    signalProviderId: string,
    userName: string,
    profileName: string,
    profile: string
  }
};

export const onError = (): ProfileResponse => ({
  error: {
    status: "error",
    message: "Profile request fail"
  },
  success: null
});

const onSuccess = (response: ResponseUser): ProfileResponse => {
  const user = {
    accountNumber: response.data.accountNumber,
    firstName: response.data.firstName,
    lastName: response.data.lastName,
    primaryPhone: response.data.primaryPhone,
    wagerStatus: response.data.wagerStatus,
    emailAddress: response.data.emailAddress,
    homeAddress: response.data.homeAddress,
    signalProviderId: response.data.signalProviderId,
    userName: response.data.userName,
    profile: response.data.profileName || response.data.profile,
    accountRoles: response.data.accountRoles
  };

  return {
    error: null,
    success: {
      status: "success",
      data: {
        user
      }
    }
  };
};

export default (userId: string): Promise<ProfileResponse> =>
  axios({
    method: "get",
    url: `${TVGConf().config().service.uam}/users/${userId}/profile`,
    headers: tvgHeaders(),
    withCredentials: true
  })
    .then(onSuccess)
    .catch(onError);
